
      import '@folkjs/labs/standalone/folk-shape-attribute';
      import { mergeShapesByClick } from '@folkjs/labs/interactions/canvas';

      let ac = null;
      const main = document.querySelector('main');
      const group = document.querySelector('button');

      group.addEventListener('click', async () => {
        if (ac) {
          ac?.abort();
        } else {
          ac = new AbortController();
          const section = await mergeShapesByClick(ac.signal, main);
          ac = null;
        }
      });
    